<template>
  <div>
    <div :id="VIEW_LIST" v-if="viewType == VIEW_LIST">
      <div class="row center-block">
        <div class="col-md-12">
          <div class="box">
            <div class="box-header">
                <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
                <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                  <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                    <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                    <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                    <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                    <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                    <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                  </select>
                </div>          
                <div class="box-tools">              
                  <!-- <button v-on:click="onViewPdf" class="btn btn-primary">Print</button> -->
                  <button class="btn btn-default" data-toggle="modal" data-target="#modal-filter">Filter</button>
                  <button v-on:click="inquiry" class="btn btn-warning">Search</button>
                </div>
            </div>        
            <div class="box-body no-padding table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width: 45px;text-align:right;">#</th>
                    <th style="text-align:center;">Action</th>
                    <th style="text-align:left;">Name</th>
                    <th style="text-align:center;">Document Date</th>                    
                    <th style="text-align:left;">Project</th>                    
                    <th style="text-align:right;">Amount</th>
                    <th style="text-align:right;">Tax</th>
                    <th style="text-align:right;">Amount Include Tax</th>
                    <th style="text-align:right;">Paid Amount</th>
                    <th style="text-align:right;">Return Amount</th>
                    <th style="text-align:center;">Currency</th>
                    <th style="text-align:left;">Customer</th>
                    <th style="text-align:center;">Session</th>
                    <th style="text-align:left;">POS</th>
                    <th style="text-align:right;">No. of Print</th>
                    <th style="text-align:center;">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in listData" v-bind:key="i">
                    <td style="width:45px;text-align:right;">{{ startSequence + i + 1}}</td>
                    <td style="width:45px;text-align:center;">
                      <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                      </a>
                    </td>
                    <td style="text-align:left;" nowrap>{{ row.name }}</td>
                    <td style="text-align:center;" nowrap>{{ row.documentDate }}</td>                    
                    <td style="text-align:left;" nowrap>{{ row.projectName }}</td>
                    <td style="text-align:right;">{{ row.totalAmount }}</td>
                    <td style="text-align:right;">{{ row.taxAmount }}</td>
                    <td style="text-align:right;">{{ row.totalAmountIncludeTax }}</td>
                    <td style="text-align:right;">{{ row.paidAmount }}</td>
                    <td style="text-align:right;">{{ row.returnAmount }}</td>
                    <td style="text-align:center;">{{ row.currencyName }}</td>
                    <td style="text-align:left;" nowrap>{{ row.customerName }}</td>
                    <td style="text-align:center;" nowrap>{{ row.sessionName }}</td>
                    <td style="text-align:left;" nowrap>{{ row.pointOfSalesName }}</td>
                    <td style="text-align:right;">{{ row.noOfPrint }}</td>
                    <td style="text-align:center;">{{ row.status }}
                      <!-- <span v-if="row.status == SESSION_NEW" class="badge bg-blue">{{ row.status }}</span>
                      <span v-if="row.status == SESSION_INPROGRESS" class="badge bg-yellow">{{ row.status }}</span>
                      <span v-if="row.status == SESSION_CLOSED" class="badge bg-green">{{ row.status }}</span> -->
                    </td>
                    <td hidden>{{ row.id }}</td>
                    <td hidden>{{ row.projectId }}</td>
                    <td hidden>{{ row.customerId }}</td>
                    <td hidden>{{ row.currencyId }}</td> 
                    <td hidden>{{ row.sessionId }}</td>
                    <td hidden>{{ row.pointOfSalesId }}</td>                     
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="box-footer">
              <div class="form-group">
                <label style="width:25px;text-align:right;">
                    <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                </label>
                <label>
                    Page
                </label>
                <label>
                    <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                </label>
                <label id="TotalPageText">
                  {{ totalPages }}                
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                </label>
                <label style="width:25px;text-align:left;">
                    <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> 
     <div class="modal fade" id="modal-view-file" style="display:none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body" style="height:500px;padding:5px;">
            <div id="reportViewer" style="width:100%;height:100%;" class="row" v-if="viewTypeReport == VIEW_REPORT">
              <iframe id="viewer" style="width:100%;height:100%;border:1px;"></iframe>
            </div>
            <div id="reportParams" class="row" v-if="viewTypeReport == VIEW_PARAMS">
              <div class="row center-block">
                <div class="col-md-12">
                  <div class="box box-info">
                      <div class="box-body">
                      <div class="form-group">
                        <label for="inputFromDate" class="col-sm-4 control-label">From Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="fromDate" :value=formRepParams.fromDate
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'fromDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedFromDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputToDate" class="col-sm-4 control-label">To Date</label>
                        <div class="col-sm-8">
                          <div class="input-group">
                            <datepicker style="width:100%" name="toDate" :value=formRepParams.toDate 
                                        :format=DATE_FORMAT
                                        :input-attr="{ 'id': 'toDate' }"
                                        :input-style="{ 'width': '100%' }"
                                        :after-picked="onPickedToDate"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>    
            </div>  
          </div>
          <div class="modal-footer" style="padding:5px;">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" @click="onPreviewPdf()" v-if="viewTypeReport == VIEW_PARAMS">View</button>
            <button type="button" class="btn btn-primary" @click="onPrintPdf()" v-if="viewTypeReport == VIEW_REPORT">Print</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modal-filter" style="display: none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span></button>
            <h4 class="modal-title">Filter</h4>
          </div>
          <div class="modal-body">
            <div class="box-body no-border form-horizontal">
              <div class="form-group">
                <label class="col-md-2 control-label">Order Name</label>
                <div class="col-md-10">
                    <input type="text" id="filterOrderName" v-model="searchParam.name" style="width:100%">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Document Date</label>
                <div class="col-md-10">
                  <div class="input-group">
                    <datepicker v-if="showDocDateFrom" ref="docDateFrom" :value=searchParam.doc_date_from :format=DATE_FORMAT :input-attr="{ 'id': 'filterDocDateFrom' }" :input-style="{ 'width': '100%' }"></datepicker>
                    <label>to</label>
                    <datepicker v-if="showDocDateTo" ref="docDateTo" :value=searchParam.doc_date_to :format=DATE_FORMAT :input-attr="{ 'id': 'filterDocDateTo' }" :input-style="{ 'width': '100%' }"></datepicker>
                  </div>
                </div>                     
              </div>               
              <div class="form-group">
                <label class="col-md-2 control-label">Status</label>
                <div class="col-md-10">
                  <input type="text" id="filteStatus" v-model="searchParam.status" style="width:100%">
                </div>                     
              </div>                                                                                         
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="onApplyFilter($event)">Apply</button>
            <button type="button" class="btn btn-primary" @click="onResetFilter($event)">Reset</button>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
// import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'
import utilities from '../../utilities'
import $ from 'jquery'
import moment from 'moment'

const VIEW_LIST = 'list'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
// const MODE_UPDATE = 'update'
const SESSION_NEW = 'New'
const SESSION_INPROGRESS = 'InProgress'
const SESSION_CLOSED = 'Closed'

const VIEW_PARAMS = 'reportParams'
const VIEW_REPORT = 'reportView'

export default {
  name: 'POSSession',
  components: {
    datepicker
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      DATETIME_FORMAT_ISO: config.dateTimeFormatSql,
      VIEW_LIST: VIEW_LIST,
      SESSION_NEW: SESSION_NEW,
      SESSION_INPROGRESS: SESSION_INPROGRESS,
      SESSION_CLOSED: SESSION_CLOSED,
      VIEW_PARAMS: VIEW_PARAMS,
      VIEW_REPORT: VIEW_REPORT,
      listData: null,
      listDataTemp: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'DESC',
        SortExpression: 'DocumentDate',
        WhereClauseByProject: ''
      },
      formRepParams: {
        fromDate: '',
        toDate: ''
      },
      viewTypeReport: VIEW_PARAMS,
      viewType: VIEW_LIST,
      tabActive: '',
      listProject: null,
      listCashier: null,
      listPOS: null,
      showValidFrom: false,
      searchParam: {
        name: '',
        doc_date_from: '',
        doc_date_to: '',
        status: ''
      },
      showDocDateFrom: true,
      showDocDateTo: true
    }
  },
  computed: {
  },
  created() {
    this.viewType = VIEW_LIST
    this.viewTypeReport = VIEW_PARAMS
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    onSearch(evt) {
      // var keyWords = evt.target.value
      // var whereClause = ['Name', 'like', '\'%' + keyWords + '%\'']
      // this.inquiryParam.WhereClause = whereClause.join(' ')
      this.inquiry()
    },
    inquiry() {
      this.inquiryParam.WhereClauseByProject = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'ProjectId IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      api
        .request('POS', 'get', '/api/Order/Inquiry?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listDataTemp = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
          this.$refs.recordPerPage.value = this.inquiryParam.PageSize

          // Populate Cashier & Project
          var arrCustomer = []
          var arrProject = []
          var arrPOS = []
          var arrSession = []
          var arrCurrency = []
          this.listDataTemp.forEach(itemOrder => {
            arrCustomer.push(itemOrder.customerId)
            var arrCustomerUnique = arrCustomer.filter(function(item, index) {
              return arrCustomer.indexOf(item) >= index
            })
            arrCustomer = arrCustomerUnique

            arrProject.push(itemOrder.projectId)
            var arrProjectUnique = arrProject.filter(function(item, index) {
              return arrProject.indexOf(item) >= index
            })
            arrProject = arrProjectUnique

            arrPOS.push(itemOrder.pointOfSalesId)
            var arrPOSUnique = arrPOS.filter(function(item, index) {
              return arrPOS.indexOf(item) >= index
            })
            arrPOS = arrPOSUnique

            arrSession.push(itemOrder.sessionId)
            var arrSessionUnique = arrSession.filter(function(item, index) {
              return arrSession.indexOf(item) >= index
            })
            arrSession = arrSessionUnique

            arrCurrency.push(itemOrder.currencyId)
            var arrCurrencyUnique = arrCurrency.filter(function(item, index) {
              return arrCurrency.indexOf(item) >= index
            })
            arrCurrency = arrCurrencyUnique
          })

          this.getCustomerName(arrCustomer, arrProject, arrPOS, arrSession, arrCurrency)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getCustomerName(arrCustomer, arrProject, arrPOS, arrSession, arrCurrency) {
      let whereClause = 'id in (' + arrCustomer.join(',') + ')'
      api
        .request('Guest', 'get', '/api/Guest/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrCustomer.length +
                                      '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          this.listCustomer = data.entity

          var customerName
          this.listDataTemp.forEach(itemOrder => {
            customerName = ''
            this.listCustomer.some(function(item, index) {
              if (itemOrder.customerId === item.id) {
                customerName = (item.firstName + ' ' + item.lastName).trim()
              }
            })
            itemOrder.customerName = customerName
          })
          this.getProjectName(arrProject, arrPOS, arrSession, arrCurrency)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getProjectName(arrProject, arrPOS, arrSession, arrCurrency) {
      let whereClause = 'id in (' + arrProject.join(',') + ')'
      api
        .request('Account', 'get', '/api/Project/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrProject.length +
                                      '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          this.listProject = data.entity

          var projectName
          this.listDataTemp.forEach(itemOrder => {
            projectName = ''
            this.listProject.some(function(item, index) {
              if (itemOrder.projectId === item.id) {
                projectName = item.name
              }
            })
            itemOrder.projectName = projectName
          })
          this.getPointOfSalesName(arrPOS, arrSession, arrCurrency)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getPointOfSalesName(arrPOS, arrSession, arrCurrency) {
      let whereClause = 'id in (' + arrPOS.join(',') + ')'
      api
        .request('POS', 'get', '/api/POS/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrPOS.length +
                                      '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          this.listPOS = data.entity

          var pointOfSalesName
          this.listDataTemp.forEach(itemOrder => {
            pointOfSalesName = ''
            this.listPOS.some(function(item, index) {
              if (itemOrder.pointOfSalesId === item.id) {
                pointOfSalesName = item.name
              }
            })
            itemOrder.pointOfSalesName = pointOfSalesName
          })
          this.getSessionName(arrSession, arrCurrency)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getSessionName(arrSession, arrCurrency) {
      let whereClause = 'id in (' + arrSession.join(',') + ')'
      api
        .request('POS', 'get', '/api/Session/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrSession.length +
                                      '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          this.listSession = data.entity

          var sessionName
          this.listDataTemp.forEach(itemOrder => {
            sessionName = ''
            this.listSession.some(function(item, index) {
              if (itemOrder.sessionId === item.id) {
                sessionName = item.name
              }
            })
            itemOrder.sessionName = sessionName
          })
          this.getCurrencyName(arrCurrency)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getCurrencyName(arrCurrency) {
      let whereClause = 'id in (' + arrCurrency.join(',') + ')'
      api
        .request('Account', 'get', '/api/Currency/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrCurrency.length +
                                      '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          this.listCurrency = data.entity

          var currencyName
          this.listDataTemp.forEach(itemOrder => {
            currencyName = ''
            this.listCurrency.some(function(item, index) {
              if (itemOrder.currencyId === item.id) {
                currencyName = item.name
              }
            })
            itemOrder.currencyName = currencyName
          })
          this.listData = this.listDataTemp
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onPickedFromDate(date) {
      this.formRepParams.fromDate = date
    },
    onPickedToDate(date) {
      this.formRepParams.toDate = date
    },
    onCreate() {
      let params = {
        id: 0,
        mode: MODE_CREATE
      }
      this.$router.push({ name: 'POS Order', params: params })
    },
    onDisplay(row) {
      let params = {
        id: row.id,
        mode: MODE_VIEW,
        callback: this.$route.name
      }
      this.$router.push({ name: 'POS Order', params: params })
    },
    onViewPdf() {
      window.$('#modal-view-file').modal('show')
      this.viewTypeReport = VIEW_PARAMS
    },
    onPreviewPdf() {
      if (this.formRepParams.fromDate !== '' && this.formRepParams.toDate !== '') {
        var validFrom = utilities.ParseDate(this.formRepParams.fromDate, this.DATE_FORMAT)
        var validTo = utilities.ParseDate(this.formRepParams.toDate, this.DATE_FORMAT)
        var paramFrom = utilities.DisplayDate(validFrom, 'yyyy-MM-dd')
        var paramTo = utilities.DisplayDate(validTo, 'yyyy-MM-dd')
        var params = 'mainProjectId=4;projectName=The Avani;mainDateStart=' + paramFrom + ';mainDateEnd=' + paramTo
        this.viewTypeReport = VIEW_REPORT
        api.request('POS', 'get', '/api/POS/PrintReports?fileReports=emembers_reports/daily_order_peritems.pdf&paramsReports=' + params, null, 'blob')
          .then(response => {
            const objUrl = window.URL.createObjectURL(response.data)
            const iframe = window.$('#viewer')[0]
            iframe.setAttribute('src', objUrl + '#toolbar=0&navpanes=1&scrollbar=0&view=Fit')
            window.$('#modal-view-file').modal('show')
            window.URL.revokeObjectURL(objUrl)
          })
      }
    },
    onPrintPdf() {
      const iframe = window.$('#viewer')[0]
      iframe.focus()
      iframe.contentWindow.print()
    },
    // onEdit(row) {
    //   let params = {
    //     id: row.id,
    //     mode: MODE_UPDATE
    //   }
    //   this.$router.push({ name: 'POSSessionForm', params: params })
    // }
    onApplyFilter() {
      var filterParams = []
      if (this.searchParam.name !== '') {
        filterParams.push(['name', '=', '\'' + this.searchParam.name + '\''])
      }

      let dateFrom
      if ($('#filterDocDateFrom').val() === '') {
        dateFrom = moment('01.01.1900', this.DATE_FORMAT)
      } else {
        this.searchParam.doc_date_from = $('#filterDocDateFrom').val()
        dateFrom = moment(this.searchParam.doc_date_from, this.DATE_FORMAT)
      }
      dateFrom = moment(dateFrom).format(this.DATE_FORMAT_ISO) + ' 00:00:00'
      dateFrom = this.convertToUtcTime(dateFrom, this.DATETIME_FORMAT_ISO)
      filterParams.push(['DocumentDate', '>=', '\'' + dateFrom + '\''])

      let dateTo
      if ($('#filterDocDateTo').val() === '') {
        dateTo = moment('31.12.9999', this.DATE_FORMAT)
      } else {
        this.searchParam.doc_date_to = $('#filterDocDateTo').val()
        dateTo = moment(this.searchParam.doc_date_to, this.DATE_FORMAT)
      }
      dateTo = moment(dateTo).format(this.DATE_FORMAT_ISO) + ' 00:00:00'
      dateTo = this.convertToUtcTime(dateTo, this.DATETIME_FORMAT_ISO)
      filterParams.push(['DocumentDate', '<=', '\'' + dateTo + '\''])

      if (this.searchParam.status !== '') {
        filterParams.push(['status', '=', '\'' + this.searchParam.status + '\''])
      }

      var whereClause = []
      var j = 0
      for (let i = 0; i < filterParams.length; i++) {
        whereClause[j] = filterParams[i].join(' ')
        j++
      }
      this.inquiryParam.WhereClause = whereClause.join(' AND ')
      this.onSearch()
    },
    onResetFilter() {
      this.inquiryParam.WhereClause = ''
      this.searchParam.name = ''

      this.searchParam.doc_date_from = ''
      this.searchParam.doc_date_to = ''

      this.searchParam.status = ''

      this.showDocDateFrom = false
      this.$nextTick(() => {
        this.showDocDateFrom = true
      })

      this.showDocDateTo = false
      this.$nextTick(() => {
        this.showDocDateTo = true
      })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// POSOrder.vue?0ac4d1a5